import React from "react";
import "./PieChart.css"
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = React.memo(() => {

    const percent = [10, 35, 25, 30]

    const data = {
        datasets: [{
            labels: ['Regular Payroll', 'Off cycle Payroll', 'Expenses management', 'Timecard management'],
            data: percent,
            backgroundColor: ['rgba(230, 247, 255, 1)', 'rgba(186, 231, 255, 1)', 'rgba(0, 80, 179, 1)', 
            'rgba(0, 58, 140, 1)',],
            borderColor: ['rgba(230, 247, 255, 1)', 'rgba(186, 231, 255, 1)', 'rgba(0, 80, 179, 1)', 
            'rgba(0, 58, 140, 1)',],
            hoverBackgroundColor: ['rgba(230, 247, 255, 1)', 'rgba(186, 231, 255, 1)', 'rgba(0, 80, 179, 1)', 
            'rgba(0, 58, 140, 1)',],
            cutout: "75%",
        }],
    }

    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.labels[context.dataIndex];
                        return `${label}`;
                    },
                },
            },
        },
    };

    const textCenter = {
        id: 'textCenter',
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, chartArea, config } = chart;
            const { data: { datasets } } = config;
            const centerX = chart.getDatasetMeta(0).data[0].x;
            const centerY = chart.getDatasetMeta(0).data[0].y;

            const fontSize = 12; // Set the desired font size
            ctx.font = `${fontSize}px Arial`; // Specify the font size and family
            ctx.textAlign = 'left'; // Set text alignment to left
            ctx.textBaseline = 'middle';

            const bullet = '\u2022';
            const bulletColor = ['rgba(230, 247, 255, 1)', 'rgba(186, 231, 255, 1)', 'rgba(0, 80, 179, 1)', 'rgba(0, 58, 140, 1)',];
            const textColor = 'rgba(0, 58, 140, 1)'; // Set the color for the text

            const textLines = [`Regular Payroll: ${percent[0]}%`, `Off cycle Payroll: ${percent[1]}%`,
            `Expenses management: ${percent[2]}%`, `Timecard management: ${percent[3]}%`];

            textLines.forEach((line, index) => {
                const offsetY = (index - (textLines.length - 1) / 2) * 30;

                ctx.fillStyle = bulletColor[index];

                ctx.save(); // Save the current context state

                ctx.font = `${18 * 2}px Arial`; // Increase the bullet font size
                ctx.fillText(bullet, centerX - 90, centerY + offsetY); // Adjust the x-coordinate for the bullet

                ctx.restore(); // Restore to the previous context state

                // Set the fillStyle for the text
                ctx.fillStyle = textColor;

                // Draw the text to the left of the bullet
                const textX = centerX - 72; // Adjust the x-coordinate for the text
                ctx.fillText(line, textX, centerY + offsetY);
            });
        },
    };


    return (<>
        <div className="piechart-wholediv">
            <Doughnut data={data} options={options} plugins={[textCenter]} className="doughnut-chart" />
        </div>
    </>);
}
);
export default PieChart;
